import styled from 'styled-components'
import { black, orange } from '@/theme/colors'

export const DateSelectorContainer = styled.div`
	display: flex;
	justify-content: flex-start;
	padding: 0 1rem 1.5rem 1rem;
	flex-shrink: 0;
`

export const DateRangeDisplay = styled.div`
	display: flex;
	align-items: center;
	gap: 0.75rem;
`

export const DateDisplayText = styled.div`
	display: flex;
	align-items: center;
	gap: 0.5rem;
`

export const DateDisplayValue = styled.div`
	font-size: 1.1rem;
	color: #212529;
	font-weight: 500;
`

export const DateSeparator = styled.span`
	font-weight: 400;
	color: #6c757d;
	font-size: 0.95rem;
`

export const DaysCount = styled.span`
	padding: 0.4rem 1rem;
	background: white;
	color: ${black};
	border-radius: 20px;
	font-size: 0.95rem;
	font-weight: 600;
	white-space: nowrap;
	border: 2px solid #e9ecef;
`

export const EditButton = styled.button`
	background: transparent;
	color: ${orange};
	border: none;
	padding: 0;
	font-weight: 600;
	font-size: 0.95rem;
	cursor: pointer;
	transition: all 0.2s ease;
	white-space: nowrap;

	&:hover {
		opacity: 0.8;
		text-decoration: underline;
	}

	&:active {
		opacity: 0.7;
	}
`
